module.exports = __webpack_public_path__ + "img/mask.ae64c00c.svg";